// extracted by mini-css-extract-plugin
export var activityContainer = "_mp-0";
export var typingIndicatorContainer = "_mp-1";
export var typingIndicatorDot = "_mp-2";
export var wave = "_mp-3";